import React, { useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View, TextInput } from 'react-native';
import { DataStore } from 'aws-amplify';
import { UserGroup, Cooperation, UserType, GroupConversation, Conversation } from '../../models';
import { Picker } from '@react-native-picker/picker';
import * as DataStoreUtil from '../../components/DataStoreUtil';
import * as CmnUtil from '../../components/CmnUtil';
import * as AppConst from '../../components/AppConst';

/** ================================
*  組織追加画面
*  ================================*/
const AddGroup = ({ closeFunction }: { closeFunction: Function }) => {
  // 各種情報
  const [groupName, setGroupName] = useState('');
  const [groupType, setGroupType] = useState<string>('');

  // 組織登録メイン
  const addGroup = async () => {
    CmnUtil.startLoading();
    // エラーチェック
    if (groupName.length == 0) {
      CmnUtil.appAlert('組織名は必須入力です。');
      CmnUtil.endLoading();
      return;
    }
    if (groupType.length == 0) {
      CmnUtil.appAlert('タイプは必須入力です。');
      CmnUtil.endLoading();
      return;
    }

    // 組織データ作成
    const result = await addGroupData();
    if (!result) {
      CmnUtil.appAlert('組織登録に失敗しました。');
      CmnUtil.endLoading();
      return;
    }

    CmnUtil.endLoading();
    CmnUtil.appMsg('組織を登録しました。');
    closeFunction();
  }

  // DataStoreへの登録
  const addGroupData = async () => {
    // UserGroupの登録
    const tmpType = groupType == UserType.INSTRUCTOR ? UserType.INSTRUCTOR : UserType.PRODUCER;
    const newGroup = await DataStore.save(new UserGroup({
      groupName: groupName,
      groupType: tmpType,
    }));

    // 単一グループのConversation
    const innerConv = await DataStore.save(new Conversation({}));
    await DataStore.save(new GroupConversation({ group: newGroup, conversation: innerConv, isIntergroup: false }));

    // Cooperationの登録
    // 管理者とは標準で協力関係になる
    const adminGroups = (await DataStore.query(UserGroup, c => c.groupType('eq', UserType.ADMINISTRATOR)));
    for (const adminGroup of adminGroups) {
      // newGroup -> adminGroup
      const cooperationTo = (await DataStore.query(Cooperation, c => c.groupID('eq', newGroup.id).cooperationGroupID('eq', adminGroup.id)));
      if (cooperationTo.length == 0) {
        await DataStore.save(new Cooperation({
          groupID: newGroup.id,
          cooperationGroupID: adminGroup.id,
        }));
      }

      // adminGroup -> newGroup
      const cooperationFrom = (await DataStore.query(Cooperation, c => c.groupID('eq', adminGroup.id).cooperationGroupID('eq', newGroup.id)));
      if (cooperationFrom.length == 0) {
        await DataStore.save(new Cooperation({
          groupID: adminGroup.id,
          cooperationGroupID: newGroup.id,
        }));
      }

      // Conversation
      const conversation = await DataStore.save(new Conversation({}));

      // GroupConversation
      await DataStore.save(new GroupConversation({ group: adminGroup, conversation: conversation, isIntergroup: true }));
      await DataStore.save(new GroupConversation({ group: newGroup, conversation: conversation, isIntergroup: true }));
    }
    return true;
  }

  return (
    <View style={AppConst.styles.dialog}>
      <View style={AppConst.styles.dialogContents}>
        <View style={{ backgroundColor: AppConst.defaultBaseColor, width: 450, borderRadius: 10 }}>
          <AppConst.DialogHeader closeFunction={closeFunction} />

          <View style={{ padding: 10 }}>
            <View style={styles.box}>
              <Text>組織名</Text>
              <TextInput
                style={styles.textInput}
                value={groupName}
                onChangeText={setGroupName}
                textContentType='none'
                autoCapitalize='none'
              />
            </View>

            <View style={styles.box}>
              <Text>タイプ</Text>
              <Picker
                selectedValue={groupType}
                style={styles.textInput}
                onValueChange={(itemValue, itemIndex) =>
                  setGroupType(itemValue)
                }>
                <Picker.Item label='選択してください' value='' />
                <Picker.Item label={DataStoreUtil.convUserType(UserType.INSTRUCTOR)} value={UserType.INSTRUCTOR} />
                <Picker.Item label={DataStoreUtil.convUserType(UserType.PRODUCER)} value={UserType.PRODUCER} />
              </Picker>
            </View>

            <TouchableOpacity style={styles.addButton} onPress={addGroup}>
              <Text style={{ color: AppConst.defaultTextColor }}>組織登録</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    marginTop: 10,
  },
  textInput: {
    borderBottomWidth: 1,
    backgroundColor: AppConst.defaultBaseInputColor,
    height: 30,
    paddingLeft: 5,
  },
  addButton: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: AppConst.defaultColor,
    height: 30,
    marginTop: 30,
    marginBottom: 20,
  },
});

export default AddGroup;
